import { render, staticRenderFns } from "./BaseIndicator.vue?vue&type=template&id=0ba3865e&scoped=true"
import script from "./BaseIndicator.vue?vue&type=script&lang=js"
export * from "./BaseIndicator.vue?vue&type=script&lang=js"
import style0 from "./BaseIndicator.vue?vue&type=style&index=0&id=0ba3865e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba3865e",
  null
  
)

export default component.exports